import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { client } from '../../utils/contentfulClient';
import { Helmet } from 'react-helmet-async';
import port from './Portfolio.module.css';


function PortfolioFeed() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.getEntries({ 
      content_type: 'portfolioProject',
      order: '-sys.createdAt',
      // Tell Contentful to only return posts where Target Site is one of these two values:
      'fields.targetSite': process.env.REACT_APP_SITENAME
    })
      .then((response) => {
        setProjects(response.items);
        setLoading(false);
      })
      .catch(console.error);
  }, []);

  if (loading) return <p style={{ textAlign: 'center', marginTop: '50px' }}>Loading portfolio...</p>;

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
      <Helmet>
        <title>Portfolio | Phoenix Object Conservation</title>
      </Helmet>
      
      <div id={port.intro}>
          <h1 id={port.h1}>My Portfolio</h1>
          <span className="font_didot_20">Welcome to my portfolio. Here you’ll find a selection of my work. Explore my projects to learn more about what I do.</span>
      </div>
      
      <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))' }}>
        {projects.map((project) => (
          <Link key={project.sys.id} to={`/portfolio/${project.fields.slug}`} style={{ textDecoration: 'none' }}>
            {/* The relative container for the hover effect */}
            <div 
              style={{ position: 'relative', overflow: 'hidden', borderRadius: '8px', aspectRatio: '4/3' }}
              // Simple inline hover state handler
              onMouseEnter={(e) => e.currentTarget.lastChild.style.opacity = '1'}
              onMouseLeave={(e) => e.currentTarget.lastChild.style.opacity = '0'}
            >
              {project.fields.coverImage && (
                <img 
                  src={`https:${project.fields.coverImage.fields.file.url}?w=600&h=450&fit=fill`} 
                  alt={project.fields.title} 
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
              )}
              
              {/* The Hover Overlay */}
              <div style={{
                position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(44, 62, 80, 0.45)', // BRAND_COLOR with transparency
                color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
                opacity: 0, transition: 'opacity 0.3s ease', padding: '20px', textAlign: 'center'
              }}>
                <h3 style={{ fontSize: '1.5rem', fontWeight: '400', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  {project.fields.title}
                </h3>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default PortfolioFeed;